import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useStore } from "effector-react";
import { AccountsBlock } from "../../accounts/organoids/AccountsBlock";
import { ChargesBlock } from "../../charges/organoids/ChargesBlock";
import { CountersBlock } from "../../counters/organoids/CountersBlock";
import { loggedIn } from "../../login/logics/reg";
import { pathLogin } from "../../../common/config/vars";
import { $accounts } from "../../../common/accounts2";

import "../styles/Main.css";
import { keyIntfCounters, keyIntfCharges } from "../../../common/disabledInterfaces";
import { AccessControl } from "../../../common/ui/AccessControl";
import { PaymentsBlock } from "../../payments/organoids/Payments";
import { $SiteColors } from "../../../common/config/company-atts";
interface IMain {
  searchParams: object
}

export const Main = ({searchParams}: IMain) => {
  const { accounts } = useStore($accounts);
  const [lookButtonIsClicked, setLookButtonIsClicked] = React.useState(false);
  useEffect(() => {
    //const msg = firebase.messaging()
  // msg.usePublicVapidKey("BKNf0lAUm5s6Cb87ICD2c84FNEsL8H__fKDZJCqY4qwnqPVj4q8BT_o5x4dHBfjMi9sI-ZvuhEIskjmI6nM8bgw")
      /*msg.requestPermission().then(() => { //MAIN_MAIN_WORK
        return msg.deleteToken()
      }).then((refreshedToken) => {
        console.log('Token deleted.', refreshedToken);
        
      }).catch((err) => {
        console.log('Unable to deleted token ', err);
      });*/
    /*Notification.requestPermission().then(() => {

    })*/
    /*if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('../../../common/config/firebase-messaging-sw.js')
      .then(function(registration) {
        console.log('Registration successful, scope is:', registration.scope);
      }).catch(function(err) {
        console.log('Service worker registration failed, error:', err);
      });
    }*/
    /*msg.getToken({vapidKey: "BKNf0lAUm5s6Cb87ICD2c84FNEsL8H__fKDZJCqY4qwnqPVj4q8BT_o5x4dHBfjMi9sI-ZvuhEIskjmI6nM8bgw"}).then((token) => {
      console.log("TOKEN:", token)

    }).catch((e) => {
      console.log("TOKEN_ERROR:", e)
    })*/

    /*Notification.requestPermission().then((permission) => {
      console.log('PERMISSION:', permission);
		  if (permission === 'granted') {
			console.log('Notification permission granted.');
		  } else {
			console.log('Unable to get permission to notify.');
		  }
    })*/

    /*notificationSubscribe()
    console.log("addEventListener::::--+++:");
    navigator.serviceWorker.addEventListener("message", (message) => {
        console.log("message::::--+++:");
        console.log(message);
        let dat = message.data.data as object
        console.log(createPathByActivities(dat))
    });*/

  }, [])
  const [loading, setLoading]=useState<boolean>(false)
  return !loggedIn() ? ( // тут был !loggedIn()
    <Redirect to={pathLogin} />
  ) : (
    <section className="page__content page__content_overflow">
      <h1 className="page__title" style={{color:$SiteColors.getState().titleColor}}>Главная</h1>
      <div className="page__data" style={{backgroundColor:$SiteColors.getState().cardBackgroundColor}}>
        <AccountsBlock searchParams={searchParams}  setLookButtonIsClicked={setLookButtonIsClicked} loading={loading} setLoading={setLoading}/>
        {accounts.length !== 0 && !loading && (
          <>
            <AccessControl intf={keyIntfCounters} ok={<CountersBlock />} />
            <AccessControl intf={keyIntfCharges} ok={<ChargesBlock lookButtonIsClicked={lookButtonIsClicked} setLookButtonIsClicked={setLookButtonIsClicked}/>} />
            <PaymentsBlock />
          </>
        )}
      </div>
    </section>
  );
};
